import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="relative rounded-3xl overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20reading%20atmosphere%2C%20cozy%20reading%20nook%20with%20warm%20lighting%2C%20abstract%20artistic%20illustration%2C%20soft%20cream%20and%20golden%20tones%2C%20comfortable%20vibes%2C%20cinematic%20composition%2C%20film%20grain%20texture%2C%20book%20and%20coffee%20aesthetic&width=1400&height=600&seq=cta-bg-comics&orientation=landscape"
            alt="开始阅读韩漫"
            className="w-full h-[320px] md:h-[400px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/70 to-foreground-950/30"></div>
          <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight mb-3">
              准备好开始你的
              <br />
              <span className="italic font-light text-foreground-300">韩漫之旅</span>
              <span className="font-black"> 了吗？</span>
            </h2>
            <p className="text-foreground-300 text-sm md:text-base mb-8 max-w-md">
              海量免费韩国漫画等你来发现，立即加入我们
            </p>
            <Link
              to="/category/all"
              className="px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full transition-colors whitespace-nowrap cursor-pointer text-sm"
            >
              立即开始阅读
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}